"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.spotComponent = exports.SpotComponent = void 0;
const app_1 = require("app");
class SpotComponent extends app_1.Component {
    constructor() {
        super(...arguments);
        this.selector = '.spot-singlelink, .spot-multilink, .spot-two_plus_one';
        this.moreInfoControlsSelector = '.expandable-text-controls';
        this.descriptionSelector = '.spot-content__description';
        this.readMoreBtnClass = 'expandable-text-read-more';
        this.readLessBtnClass = 'expandable-text-read-less';
        this.VISIBLE_LINES_COUNT_ON_MOBILE = 3;
        this.BASE_LINE = 24;
        this.visibleAreaMaxHeight = this.BASE_LINE * this.VISIBLE_LINES_COUNT_ON_MOBILE;
        this.mobileViewInitialized = false;
        this.initMobileView = () => {
            this.handleMobileDescription();
            this.mobileViewInitialized = true;
        };
        this.dismissMobileView = () => {
            this.el.forEach(el => {
                const moreInfoControls = el.querySelectorAll(this.moreInfoControlsSelector);
                this.hideMoreInfoControls(moreInfoControls);
            });
        };
        this.handleMobileDescription = () => {
            this.el.forEach(el => {
                const description = el.querySelector(this.descriptionSelector);
                const moreInfoControls = el.querySelectorAll(this.moreInfoControlsSelector);
                if (description && description.scrollHeight <= this.visibleAreaMaxHeight) {
                    this.hideMoreInfoControls(moreInfoControls);
                }
                else {
                    this.showMoreInfoControls(moreInfoControls);
                }
                if (!this.mobileViewInitialized) {
                    this.attachMoreInfoButtonsHandlers(description, moreInfoControls);
                }
            });
        };
    }
    OnInit() {
        this.initHeadingExternalIcon();
        if ((0, app_1.isMobile)()) {
            this.initMobileView();
        }
    }
    OnWindowResizeThrottle() {
        if ((0, app_1.isMobile)()) {
            if (!this.mobileViewInitialized) {
                this.initMobileView();
            }
            else {
                this.handleMobileDescription();
            }
        }
        else if (this.mobileViewInitialized) {
            this.dismissMobileView();
        }
    }
    initHeadingExternalIcon() {
        this.el.forEach(el => {
            // Heading link
            const spotLink = el.querySelector('.spot-link');
            if (spotLink) {
                const externalLink = new app_1.ExternalLink();
                if (externalLink.isExternal(spotLink)) {
                    externalLink.insertIcon(el.querySelector('.spot-content__title'), 'text-[length:inherit]');
                }
            }
        });
    }
    attachMoreInfoButtonsHandlers(description, moreInfoControls) {
        moreInfoControls.forEach(moreInfoControl => {
            moreInfoControl.addEventListener('click', e => {
                const targetEl = e.target;
                if (targetEl.classList.contains(this.readMoreBtnClass)) {
                    this.expandMobileDescription(description);
                }
                else if (targetEl.classList.contains(this.readLessBtnClass)) {
                    this.collapseMobileDescription(description);
                }
                return false;
            });
        });
    }
    showMoreInfoControls(moreInfoControls) {
        moreInfoControls.forEach(moreInfoControl => moreInfoControl.classList.add('!block'));
    }
    hideMoreInfoControls(moreInfoControls) {
        moreInfoControls.forEach(moreInfoControl => moreInfoControl.classList.remove('!block'));
    }
    expandMobileDescription(description) {
        description.classList.remove('line-clamp-3');
    }
    collapseMobileDescription(description) {
        description.classList.add('line-clamp-3');
    }
}
exports.SpotComponent = SpotComponent;
exports.spotComponent = new SpotComponent();
